import {z} from 'zod';

import {ArticleState} from '@dms/shared-aftersales';

export const ReceiveNoteItemDetailSchema = (articleState: ArticleState | null) => {
  const doesNotExist = articleState === 'doesNotExist';

  const receiveNoteItemSchema = z.object({
    quantity: z.number().positive(),
    unitPrice: z.number().positive(),
    totalPrice: z.number().positive(),
    vatType: z.string(),
  });

  const deliveryItemSchema = z.object({
    quantityVerified: z.number().positive(),
    purchasePriceVerified: z.number().positive(),
    stockValueVerified: z.number().positive(),
    vatType: z.string(),
  });

  const supplierArticleSchema = z.object({
    supplierQuantity: z.number().positive(),
    supplierUnitId: z.string().min(1),
    warehouseQuantity: z.number().positive(),
    warehouseUnitId: z.string().nullish(),
    supplierOrderingNumber: z.string().nullish(),
    supplierBulkPackageQuantity: z.number().nullish(),
    supplier: z.string().nullish(),
    supplierDiscountGroup: z.string().nullish(),
  });

  return z.object({
    article: doesNotExist
      ? z.object({
          catalogNumber: z.string(),
          manufacturerId: z.string(),
          warehouseId: z.string(),
          name: z.string(),
          storageLocation: z.string().nullish(),
          handlingUnit: z.string(),
          dispensingUnit: z.number().nullish(),
          leafId: z.string().nullish(),
          supplierId: z.string().nullish(),
        })
      : z.record(z.any()),
    receiveNoteItem: doesNotExist ? z.record(z.any()) : receiveNoteItemSchema,
    deliveryItem: doesNotExist ? z.record(z.any()) : deliveryItemSchema,
    supplierArticle: doesNotExist ? z.record(z.any()) : supplierArticleSchema,
  });
};

export type ReceiveNoteItemFormType = z.infer<ReturnType<typeof ReceiveNoteItemDetailSchema>>;
